import { NgModule } from '@angular/core';

import { SegurosComponent } from './seguros.component';
import { SharedModule } from "../../shared/shared.module";
import { SeguroApiService } from "./shared/seguro-api.service";
import { SeguroNavigationService } from "./shared/seguro-navigation.service";
import { SeguroService } from "./shared/seguro.service";
import { SeguroFormComponent } from "./seguro-form/seguro-form.component";
import { SeguroListComponent } from "./seguro-list/seguro-list.component";
import { SegurosRoutingModule } from "./seguros-routing.module";

@NgModule({
  imports: [
    SharedModule,
    SegurosRoutingModule
  ],
  providers: [
    SeguroApiService,
    SeguroNavigationService,
    SeguroService
  ],
  declarations: [
    SegurosComponent,
    SeguroFormComponent,
    SeguroListComponent
  ]
})
export class SegurosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/seguros.module.ts
 **/